<template>
  <div id="app">
    <div style="display:none" v-html="comments">{{ comments }}</div>
    <main-header></main-header>
    <router-view/>
    <main-footer></main-footer>
    <cookie-consent />
  </div>
</template>

<script>
import 'swiper/dist/css/swiper.css'
import MainHeader from '@/components/partials/MainHeader'
import MainFooter from '@/components/partials/MainFooter'

export default {
  name: 'App',
  components: {
    MainHeader,
    MainFooter
  },
  data () {
    return {
      comments: '<!-- Netmatters Uptime Ping Test Response -->'
    }
  }
}
</script>

<style lang="scss">

  /*******BOOTSTRAP OVERRIDES********/
  $container-max-widths: (
    sm: 540px,
    md: 720px,
    lg: 960px,
    xl: 1170px,
  );

  $grid-breakpoints: (
    xs: 0,
    sm: 576px,
    md: 768px,
    lg: 992px,
    xl: 1218px,
  );
  $custom-control-indicator-checked-bg: #b11f24;

  @import "../node_modules/bootstrap/scss/bootstrap.scss";
  @import "../src/assets/styles/bootstrap.scss";
  @import "../src/assets/styles/main.scss";

  $cookieconstent-background: $primary-colour-two;
  $cookieconstent-compliance-color: #fff;
  $cookieconstent-compliance-background:  $primary-colour-one;
  $cookieconstent-compliance-border: none;
  $cookieconstent-compliance-padding: 0;

  @import "./node_modules/vue-cookieconsent-component/src/scss/cookie-consent";
  @import "./node_modules/vue-cookieconsent-component/src/scss/cookie-consent-bottom";
  @import "./node_modules/vue-cookieconsent-component/src/scss/cookie-consent-transition";

  .cookie-consent-message {
    color: #fff;
  }

  .cookie-consent-link {
    text-decoration: underline;
  }

  .cookie-consent-compliance {
    border-radius: 5px;
    font-size: 15.82px;
    font-weight: 600;
    line-height: 50px;
    width: 168px;
    transition: background-color 0.2s;

    &:hover {
      background-color: lighten($primary-colour-one, 10%);
    }
  }

  body {
    margin: 0 !important;
  }

  .bm-menu {
    background-color: $primary-colour-two !important;
  }

  .bm-burger-button {
    display: none;
  }

  @media screen and (max-width: $xl-breakpoint) {
    .bm-burger-button {
      display: block;
    }
    .bm-burger-bars {
      background-color: $primary-colour-one;
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue